'use client';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Box, Grid, InputAdornment, Typography, Link } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SearchIcon from '@mui/icons-material/Search';
import { MuiTextField } from '@/components/textfield/MuiTextField';
import { MuiButton } from '@/components/button/MuiButton';

type Props = {
  isPublicSearch: boolean;
};

export function SearchBox({ isPublicSearch }: Props) {
  const { control, register } = useFormContext();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Link
        href={`/${isPublicSearch ? 'public' : 'app'}/stations/search/`}
        color="#13131D"
        underline="none"
      >
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            '@media (max-width: 800px)': {
              gap: 1,
            },
          }}
        >
          <NavigateBeforeIcon fontSize="large" />
          <Typography variant="JP/Heading/xl/Bold/Tight">
            看護・介護サービス名から検索
          </Typography>
        </Box>
      </Link>

      <Grid container>
        <Grid
          size={{
            md: 3,
          }}
        >
          <MuiTextField
            fullWidth
            name={register('portal_office_name').name}
            control={control}
            placeholder="看護・介護サービス名"
            sx={{ backgroundColor: '#FAFAFA' }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid
          size={{
            md: 2,
          }}
        >
          <MuiButton sx={{ ml: 1, height: 1 }} type="submit">
            検索
          </MuiButton>
        </Grid>
      </Grid>
    </Box>
  );
}
